module.exports = __webpack_public_path__ + "img/ios.0618a7ad.png";